"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuzzyQueryBank = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var FuzzyQueryBank = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FuzzyQueryBank, _super);
    function FuzzyQueryBank() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '开户行代码模糊查询接口';
        _this.code = '101063';
        _this.desc = '开户行代码模糊查询接口';
        _this.requestParams = new bankCard_1.FuzzyQueryBankRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FuzzyQueryBank;
}(service_1.BaseService));
exports.FuzzyQueryBank = FuzzyQueryBank;
//# sourceMappingURL=fuzzyQueryBank.js.map